<template>
  <div class="choosen-order">
    <Toast class="toast-msg" position="bottom-right" />
    <div v-if="this.isLoading">
      <Skeleton class="order-cards__skeleton" width="100%" height="166px" />
      <Skeleton width="180px" height="25px" style="margintop: 15px"></Skeleton>
      <Skeleton width="120px" height="20px" style="margintop: 10px"></Skeleton>
      <Skeleton class="order-cards__skeleton" width="100%" height="192px" />
      <Skeleton class="order-cards__skeleton" width="100%" height="100px" />
      <Skeleton class="order-cards__skeleton" width="100%" height="80px" />
    </div>
    <div v-else-if="this.shownOrder.Response" class="choosen-order__unfindable">
      <img
        class="choosen-order__unfindable-icon"
        :src="require(`../assets/images/errorinfo.svg`)"
        alt="info"
      />
      <p class="choosen-order__unfindable-text">Заказ не найден.</p>
    </div>
    <div v-else-if="this.shownOrder.error" class="choosen-order__unfindable">
      <img
        class="choosen-order__unfindable-icon"
        :src="require(`../assets/images/errorinfo.svg`)"
        alt="info"
      />
      <p class="choosen-order__unfindable-text">
        Заказ не найден, так как передан неверный параметр.
      </p>
    </div>
    <div v-else>
      <div class="choosen-order__info">
        <div class="choosen-order__info-wrapper">
          <p class="choosen-order__info-title">Заказ</p>
          <div class="choosen-order__info-numstat">
            <p @click="copy" class="choosen-order__info-number">
              {{ "№ " + this.shownOrder.order.Id }}
            </p>
            <div
              v-if="
                this.shownOrder.order.OrderState == 70 ||
                this.shownOrder.order.OrderState == 71 ||
                this.shownOrder.order.OrderState == 72 ||
                this.shownOrder.order.OrderState == 73 ||
                this.shownOrder.order.OrderState == 74
              "
              class="choosen-order__info-status status-canceled"
            >
              <div class="choosen-order__info-status__icon">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="red" />
                </svg>
              </div>
              <p>Отменен</p>
            </div>
            <div
              v-if="
                this.shownOrder.order.OrderState == 55 ||
                this.shownOrder.order.OrderState == 65
              "
              class="choosen-order__info-status status-processing"
            >
              <div class="choosen-order__info-status__icon">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#F37E21" />
                </svg>
              </div>
              <p>Обрабатывается</p>
            </div>
            <div
              v-if="this.shownOrder.order.OrderState == 60"
              class="choosen-order__info-status status-success"
            >
              <div class="choosen-order__info-status__icon">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#2DF321" />
                </svg>
              </div>
              <p>Оформлен</p>
            </div>
            <div
              v-if="this.shownOrder.order.OrderState == 40"
              class="choosen-order__info-status status-booked"
            >
              <div class="choosen-order__info-status__icon">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#F37E21" />
                </svg>
              </div>
              <p>Забронирован</p>
            </div>
          </div>

          <div class="choosen-order__info-created">
            <p class="choosen-order__info-created__title">Дата создания</p>
            <p class="choosen-order__info-created__value">
              {{ getCreatedDate(this.shownOrder.order.Created) }}
            </p>
          </div>
          <div
            v-if="
              getTimeLimit(this.shownOrder.order.TimeLimit) &&
              this.shownOrder.order.OrderState == 40
            "
            class="choosen-order__info-timelimit"
          >
            <p class="choosen-order__info-timelimit__title">Оплатить до</p>
            <p class="choosen-order__info-timelimit__value">
              {{ getLimitDate(this.shownOrder.order.TimeLimit) }}
            </p>
          </div>
          <div class="choosen-order__info-price">
            <p class="choosen-order__info-price__title"></p>
            <router-link
              :to="{
                name: 'OrderPrice',
              }"
              data-num="passengers"
              class="passengers-card"
            >
              <Button
                :label="
                  'Стоимость ' +
                  getTotalPrice(
                    this.shownOrder.order.PriceCalculation.Passengers
                  ) +
                  ' ₽'
                "
                class="p-button-outlined"
              />
            </router-link>
          </div>
        </div>
        <router-link
          :to="{
            name: 'Support',
            params: {
              mail: this.getRequesterMail(),
              orderId: this.shownOrder.order.Id,
            },
          }"
          class="choosen-order__info-supportbtn"
        >
          <Button
            label="Обращение в поддержку"
            class="p-button-outlined p-button-sm choosen-order__info-supportbtn"
          />
        </router-link>
        <a
          :href="`https://www.biletdv.ru/IBE/PaymentPage?orderGuid=${this.shownOrder.order.OrderGuid}`"
          class="choosen-order__info-paybtn__link"
        >
          <Button
            v-if="this.shownOrder.order.OrderState == 40"
            label="Оплатить"
            class="choosen-order__info-paybtn"
          />
        </a>
        <Button
          v-if="this.shownOrder.order.OrderState == 40"
          label="Отменить"
          class="
            p-button-outlined p-button-secondary
            choosen-order__info-cancelbtn
          "
          :loading="this.cancelLoad"
          @click="cancelOrder(this.shownOrder.order.OrderGuid)"
        />
        

        <router-link
          :to="{
            name: 'OrderDocs',
            params: {
              guid: this.shownOrder.order.OrderGuid,
              mail: this.shownOrder.order.EMail,
              orderId: this.shownOrder.order.Id,
              phone: this.shownOrder.order.Phone.Number,
              route: this.getRouteDataForLink(this.shownOrder.order.Flights),
              pnr: this.shownOrder.order.RSystemUID,
            },
          }"
          data-num="docs"
          class="passengers-card"
        >
          <Button
            v-if="this.shownOrder.order.OrderState == 60"
            label="Билеты и услуги"
            class="choosen-order__info-ticketsbtn"
          />
        </router-link>
      </div>
      <div>
        <div class="choosen-order__wrapper">
          <div v-if="this.depRoutes.length !== 0" class="choosen-order__oneway">
            <p class="choosen-order__oneway-route">
              {{
                this.depRoutes[0].Departure.City.NameRus +
                " - " +
                this.depRoutes[this.depRoutes.length - 1].Arrival.City.NameRus
              }}
            </p>
            <p class="choosen-order__oneway-text">
              {{
                getTimeOfRoute(
                  this.depRoutes[this.depRoutes.length - 1].ArrivalDateUTC,
                  this.depRoutes[0].DepartureDateUTC
                )
              }}
            </p>
            <!-- v-for depRoutes for one way -->
            <div class="choosen-order__card">
              <div v-for="(route, index) in this.depRoutes" :key="index">
                <div
                  v-if="
                    this.shownOrder.order.AeroExpress !== null &&
                    this.shownOrder.order.AeroExpress.length > 0 &&
                    isSameDayDep(
                      this.depRoutes[index],
                      this.shownOrder.order.AeroExpress
                    )
                  "
                  class="choosen-order__card-transfer-aeroexpress"
                >
                  <aero-express
                    :info="
                      getAppropriateAeroexp(
                        this.depRoutes[index],
                        this.shownOrder.order.AeroExpress
                      )
                    "
                    :schedule="this.shownOrder.order.Schedule"
                  ></aero-express>
                  <div class="choosen-order__card-transfer">
                    <div>
                      <img
                        :src="require(`../assets/images/carry.svg`)"
                        alt="Man with baggage"
                        class="choosen-order__card-transfer__icon"
                      />
                    </div>
                    <div
                      :info="this.shownOrder.order.AeroExpress[0]"
                      class="choosen-order__card-transfer__info"
                    >
                      <p class="choosen-order__card-transfer__info-city">
                        Пересадка в аэропорту
                      </p>
                    </div>
                  </div>
                </div>
                <route-card :info="this.depRoutes[index]"></route-card>
                <div
                  v-if="
                    this.shownOrder.order.AeroExpress !== null &&
                    this.shownOrder.order.AeroExpress.length > 0 &&
                    isSameDayArr(
                      this.depRoutes[index],
                      this.shownOrder.order.AeroExpress
                    )
                  "
                  class="choosen-order__card-transfer-aeroexpress"
                >
                  <div class="choosen-order__card-transfer">
                    <div>
                      <img
                        :src="require(`../assets/images/carry.svg`)"
                        alt="Man with baggage"
                        class="choosen-order__card-transfer__icon"
                      />
                    </div>
                    <div
                      :info="this.shownOrder.order.AeroExpress[0]"
                      class="choosen-order__card-transfer__info"
                    >
                      <p class="choosen-order__card-transfer__info-city">
                        Пересадка в аэропорту
                      </p>
                      <!-- <p class="choosen-order__card-transfer__info-duration">
                    {{
                        getHoursTransferTime(
                          this.depRoutes[1].DepartureDateUTC,
                          this.depRoutes[0].ArrivalDateUTC
                        )
                      }}
                    1ч 40м
                  </p> -->
                    </div>
                  </div>
                  <aero-express
                    :info="
                      getAppropriateAeroexp(
                        this.depRoutes[index],
                        this.shownOrder.order.AeroExpress
                      )
                    "
                  ></aero-express>
                </div>
                <div
                  v-if="
                    this.depRoutes[index] !==
                    this.depRoutes[this.depRoutes.length - 1]
                  "
                  class="choosen-order__card-wrapper"
                >
                  <div
                    v-if="getNightHours(this.depRoutes[index].ArrivalDate)"
                    class="choosen-order__card-transfer__night p-ripple"
                    v-ripple
                    @click="visibleBottom = true"
                  >
                    <div>
                      <img
                        :src="require(`../assets/images/carry-white.svg`)"
                        alt="Man with baggage"
                        class="choosen-order__card-transfer__icon"
                      />
                    </div>
                    <div class="choosen-order__card-transfer__info">
                      <div class="choosen-order__card-transfer__info-wrapper">
                        <p
                          class="choosen-order__card-transfer__info-city__night"
                        >
                          {{
                            "Ночная пересадка в городе " +
                            this.depRoutes[index].Arrival.City.NameRus
                          }}
                        </p>
                      </div>
                      <p
                        class="
                          choosen-order__card-transfer__info-duration__night
                        "
                      >
                        {{
                          getHoursTransferTime(
                            this.depRoutes[index + 1].DepartureDate,
                            this.depRoutes[index].ArrivalDate
                          )
                        }}
                      </p>
                      <Sidebar
                        v-model:visible="visibleBottom"
                        position="bottom"
                      >
                        <div
                          class="
                            choosen-order__card-transfer__info-night__wrapper
                          "
                        >
                          <img
                            :src="require(`../assets/images/night.svg`)"
                            alt="night"
                            class="
                              choosen-order__card-transfer__info-night__icon
                            "
                          />
                          <h3>Ночная пересадка</h3>
                        </div>
                        <p
                          class="choosen-order__card-transfer__info-night__text"
                        >
                          Придётся тратить деньги на отель или спать на лавочке.
                          К тому же некоторые аэропорты закрываются на ночь.
                        </p>
                      </Sidebar>
                    </div>
                    <img
                      :src="require(`../assets/images/information.svg`)"
                      alt="Information icon"
                      class="choosen-order__card-transfer__info-icon"
                    />
                  </div>
                  <div v-else class="choosen-order__card-transfer">
                    <div>
                      <img
                        :src="require(`../assets/images/carry.svg`)"
                        alt="Man with baggage"
                        class="choosen-order__card-transfer__icon"
                      />
                    </div>
                    <div class="choosen-order__card-transfer__info">
                      <p class="choosen-order__card-transfer__info-city">
                        {{
                          "Пересадка в городе " +
                          this.depRoutes[index].Arrival.City.NameRus
                        }}
                      </p>
                      <p class="choosen-order__card-transfer__info-duration">
                        {{
                          getHoursTransferTime(
                            this.depRoutes[index + 1].DepartureDate,
                            this.depRoutes[index].ArrivalDate
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Arrival data -->
        <div
          v-if="this.arrRoutes.length !== 0"
          class="choosen-order__oneway choosen-order__arrival-block"
        >
          <p class="choosen-order__oneway-route">
            {{
              this.arrRoutes[0].Departure.City.NameRus +
              " - " +
              this.arrRoutes[this.arrRoutes.length - 1].Arrival.City.NameRus
            }}
          </p>
          <p class="choosen-order__oneway-text">
            {{
              getTimeOfRoute(
                this.arrRoutes[this.arrRoutes.length - 1].ArrivalDate,
                this.arrRoutes[0].DepartureDate
              )
            }}
          </p>
          <!-- v-for arrRoutes for one way -->
          <div class="choosen-order__card">
            <div v-for="(route, index) in this.arrRoutes" :key="index">
              <div
                v-if="
                  this.shownOrder.order.AeroExpress !== null &&
                  this.shownOrder.order.AeroExpress.length > 0 &&
                  isSameDayDep(
                    this.arrRoutes[index],
                    this.shownOrder.order.AeroExpress
                  )
                "
                class="choosen-order__card-transfer-aeroexpress"
              >
                <aero-express
                  :info="
                    getAppropriateAeroexp(
                      this.arrRoutes[index],
                      this.shownOrder.order.AeroExpress
                    )
                  "
                ></aero-express>
                <div class="choosen-order__card-transfer">
                  <div>
                    <img
                      :src="require(`../assets/images/carry.svg`)"
                      alt="Man with baggage"
                      class="choosen-order__card-transfer__icon"
                    />
                  </div>
                  <div
                    :info="this.shownOrder.order.AeroExpress[0]"
                    class="choosen-order__card-transfer__info"
                  >
                    <p class="choosen-order__card-transfer__info-city">
                      Пересадка в аэропорту
                    </p>
                    <!-- <p class="choosen-order__card-transfer__info-duration">
                    {{
                        getHoursTransferTime(
                          this.depRoutes[1].DepartureDateUTC,
                          this.depRoutes[0].ArrivalDateUTC
                        )
                      }}
                    1ч 40м
                  </p> -->
                  </div>
                </div>
              </div>
              <route-card :info="this.arrRoutes[index]"></route-card>
              <div
                v-if="
                  this.shownOrder.order.AeroExpress !== null &&
                  this.shownOrder.order.AeroExpress.length > 0 &&
                  isSameDayArr(
                    this.arrRoutes[index],
                    this.shownOrder.order.AeroExpress
                  )
                "
                class="choosen-order__card-transfer-aeroexpress"
              >
                <div class="choosen-order__card-transfer">
                  <div>
                    <img
                      :src="require(`../assets/images/carry.svg`)"
                      alt="Man with baggage"
                      class="choosen-order__card-transfer__icon"
                    />
                  </div>
                  <div
                    :info="this.shownOrder.order.AeroExpress[0]"
                    class="choosen-order__card-transfer__info"
                  >
                    <p class="choosen-order__card-transfer__info-city">
                      Пересадка в аэропорту
                    </p>
                    <!-- <p class="choosen-order__card-transfer__info-duration">
                    {{
                        getHoursTransferTime(
                          this.depRoutes[1].DepartureDateUTC,
                          this.depRoutes[0].ArrivalDateUTC
                        )
                      }}
                    1ч 40м
                  </p> -->
                  </div>
                </div>
                <aero-express
                  :info="
                    getAppropriateAeroexp(
                      this.arrRoutes[index],
                      this.shownOrder.order.AeroExpress
                    )
                  "
                ></aero-express>
              </div>
              <div
                v-if="
                  this.arrRoutes[index] !==
                  this.arrRoutes[this.arrRoutes.length - 1]
                "
                class="choosen-order__card-wrapper"
              >
                <div
                  v-if="getNightHours(this.arrRoutes[index].ArrivalDate)"
                  class="choosen-order__card-transfer__night p-ripple"
                  v-ripple
                  @click="visibleBottom = true"
                >
                  <div>
                    <img
                      :src="require(`../assets/images/carry-white.svg`)"
                      alt="Man with baggage"
                      class="choosen-order__card-transfer__icon"
                    />
                  </div>
                  <div class="choosen-order__card-transfer__info">
                    <div class="choosen-order__card-transfer__info-wrapper">
                      <p class="choosen-order__card-transfer__info-city__night">
                        {{
                          "Ночная пересадка в городе " +
                          this.arrRoutes[index].Arrival.City.NameRus
                        }}
                      </p>
                    </div>
                    <p
                      class="choosen-order__card-transfer__info-duration__night"
                    >
                      {{
                        getHoursTransferTime(
                          this.arrRoutes[index + 1].DepartureDate,
                          this.arrRoutes[index].ArrivalDate
                        )
                      }}
                    </p>
                    <Sidebar v-model:visible="visibleBottom" position="bottom">
                      <div
                        class="
                          choosen-order__card-transfer__info-night__wrapper
                        "
                      >
                        <img
                          :src="require(`../assets/images/night.svg`)"
                          alt="night"
                          class="choosen-order__card-transfer__info-night__icon"
                        />
                        <h3>Ночная пересадка</h3>
                      </div>
                      <p class="choosen-order__card-transfer__info-night__text">
                        Придётся тратить деньги на отель или спать на лавочке. К
                        тому же некоторые аэропорты закрываются на ночь.
                      </p>
                    </Sidebar>
                  </div>
                  <img
                    :src="require(`../assets/images/information.svg`)"
                    alt="Information icon"
                    class="choosen-order__card-transfer__info-icon"
                  />
                </div>
                <div v-else class="choosen-order__card-transfer">
                  <div>
                    <img
                      :src="require(`../assets/images/carry.svg`)"
                      alt="Man with baggage"
                      class="choosen-order__card-transfer__icon"
                    />
                  </div>
                  <div class="choosen-order__card-transfer__info">
                    <p class="choosen-order__card-transfer__info-city">
                      {{
                        "Пересадка в городе " +
                        this.arrRoutes[index].Arrival.City.NameRus
                      }}
                    </p>
                    <p class="choosen-order__card-transfer__info-duration">
                      {{
                        getHoursTransferTime(
                          this.arrRoutes[index + 1].DepartureDate,
                          this.arrRoutes[index].ArrivalDate
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="choosen-order__info">
        <div class="choosen-order__info-passengers">
          <div class="choosen-order__info-passengers__wrapper">
            <p class="choosen-order__info-passengers__title">Пассажиры</p>
            <router-link
              :to="{
                name: 'OrderPassengersCard',
                params: {
                  guid: this.shownOrder.order.OrderGuid,
                },
              }"
              data-num="passengers"
              class="passengers-card"
            >
              <Button
                label="Подробнее"
                class="
                  p-button-outlined p-button-sm
                  choosen-order__info-passengers__btn
                "
              />
            </router-link>
          </div>
          <div
            v-for="(passenger, index) in this.shownOrder.order.Passengers"
            :key="index"
            class="choosen-order__info-passengers-passenger"
          >
            <div class="choosen-order__info-passengers-passenger__wrapper">
              <p class="choosen-order__info-passengers__name">
                {{
                  passenger.LastName +
                  " " +
                  passenger.FirstName +
                  " " +
                  passenger.MiddleName
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="choosen-order__info-contacts">
          <p class="choosen-order__info-contacts__title">
            Контактная информация
          </p>
          <div class="choosen-order__info-contacts__email">
            <p class="choosen-order__info-contacts__email-title">Email</p>
            <p class="choosen-order__info-contacts__email-value">
              {{ this.shownOrder.order.EMail }}
            </p>
          </div>
          <div class="choosen-order__info-contacts__phone">
            <p class="choosen-order__info-contacts__phone-title">Телефон</p>
            <p class="choosen-order__info-contacts__phone-value">
              {{ "+" + this.shownOrder.order.Phone.Number }}
            </p>
          </div>
        </div>
      </div>
      <ConfirmDialog></ConfirmDialog>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import { ref } from "vue";
  import axios from "axios";
  import Skeleton from "primevue/skeleton";
  import RouteCard from "../components/RouteCard.vue";
  import Sidebar from "primevue/sidebar";
  import Button from "primevue/button";
  import Ripple from "primevue/ripple";
  import AeroExpress from "../components/AeroExpress.vue";
  import useClipboard from "vue-clipboard3";
  import Toast from "primevue/toast";
  import { useToast } from "primevue/usetoast";
  import OrderModel from "../models/OrderModel";
  import ConfirmDialog from "primevue/confirmdialog";
  import { useRouter, useRoute } from "vue-router";
  import store from "../store";
  import { create } from "yup/lib/Reference";

  const axioCred = axios.create({
    withCredentials: true,
  });

  export default defineComponent({
    name: "Order",
    components: {
      Skeleton,
      RouteCard,
      AeroExpress,
      Sidebar,
      Button,
      Toast,
      ConfirmDialog,
    },
    props: ["order"],
    setup(props) {
      const toast = useToast();
      const router = useRouter();
      const route = useRoute();
      const { toClipboard } = useClipboard();
      let depRoutes: any[] = [];
      let arrRoutes: any[] = [];
      const isLoading = ref(false);
      const cancelLoad = ref(false);
      const error = ref(null);
      const shownOrder = ref<OrderModel | null>(null);
      const numberOfFlights = (elem: any) => {
        for (let el of elem) {
          console.log(el);
          if (el.Direction == 0) {
            depRoutes.push(el);
          } else if (el.Direction == 1) {
            arrRoutes.push(el);
          }
        }
      };
      const showSuccess = () => {
        toast.add({
          severity: "success",
          summary: "Скопировано",
          detail: "в буфер обмена",
          life: 3000,
        });
      };
      const getOrder = async () => {
        isLoading.value = true;
        try {
          const json = await axioCred.get(
            `https://www.biletdv.ru/customer/IBEServices/GetUserOrder?guid=${props.order}&priceData=none&documentsData=none`
          );
          let fetchedOrders = await json.data;
          console.log(fetchedOrders);

          shownOrder.value = fetchedOrders;
          if (
            shownOrder.value !== null &&
            (shownOrder.value.Response || shownOrder.value.error)
          ) {
            isLoading.value = false;
          } else {
            numberOfFlights(fetchedOrders.order.Flights);
            isLoading.value = false;
          }
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      };
      const copy = async () => {
        try {
          if (shownOrder.value !== null) {
            let copyString: string = JSON.stringify(shownOrder.value.order.Id);
            await toClipboard(copyString);
            showSuccess();
          }
        } catch (e) {
          console.error(e);
        }
      };
      return {
        isLoading,
        error,
        shownOrder,
        getOrder,
        numberOfFlights,
        depRoutes,
        arrRoutes,
        copy,
        showSuccess,
        cancelLoad,
      };
    },
    data() {
      return {
        visibleBottom: false,
        optnInsurOpen: [false, false, false, false, false, false, false, false],
        optnTaxOpen: [false, false, false, false, false, false, false, false],
        optnTicketOpen: [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
        visibleTickets: false,
        visiblePrice: false,
        month: [
          "янв",
          "фев",
          "мар",
          "апр",
          "мая",
          "июн",
          "июл",
          "авг",
          "сен",
          "окт",
          "ноя",
          "дек",
        ],
        hoursWords: ["час", "часа", "часов"],
        minutesWords: ["минута", "минуты", "минут"],
        activeOrder: this.$route.params,
      };
    },
    methods: {
      cancelOrder(guid: any) {
        this.$confirm.require({
          message: "Вы действительно хотите отменить заказ?",
          header: "Подтвердите отмену заказа",
          icon: "pi pi-info-circle",
          acceptClass: "p-button-danger",
          accept: () => {
            this.cancelLoad = true;
            axioCred
              .post(
                `https://www.biletdv.ru/customer/IBEServices/CancelOrder?guid=${guid}`
              )
              .then((res) => {
                if (res.status == 200) {
                  console.log(res);
                  window.location.reload();
                }
              });
          },
          reject: () => {
            //callback to execute when user rejects the action
          },
        });
      },

      isSameDayArr(route: any, aeroexp: any) {
        let toCompareDate1 = new Date(route.ArrivalDate);

        for (let i = 0; i < aeroexp.length; i++) {
          let toCompareDate2 = new Date(aeroexp[i].Time);
          if (
            toCompareDate1.getFullYear() === toCompareDate2.getFullYear() &&
            toCompareDate1.getMonth() === toCompareDate2.getMonth() &&
            toCompareDate1.getDate() === toCompareDate2.getDate()
          ) {
            if (route.Arrival.ArrAirportCodeLat == aeroexp[i].CodeDep) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      isSameDayDep(route: any, aeroexp: any) {
        let toCompareDate1 = new Date(route.DepartureDate);
        for (let i = 0; i < aeroexp.length; i++) {
          let toCompareDate2 = new Date(aeroexp[i].Time);
          if (
            toCompareDate1.getFullYear() === toCompareDate2.getFullYear() &&
            toCompareDate1.getMonth() === toCompareDate2.getMonth() &&
            toCompareDate1.getDate() === toCompareDate2.getDate()
          ) {
            if (route.Departure.DepAirportCodeLat == aeroexp[i].CodeArr) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      getAppropriateAeroexp(route: any, aeroexp: any) {
        let toCompareDate1 = new Date(route.DepartureDate);
        for (let i = 0; i < aeroexp.length; i++) {
          let toCompareDate2 = new Date(aeroexp[i].Time);
          if (
            toCompareDate1.getFullYear() === toCompareDate2.getFullYear() &&
            toCompareDate1.getMonth() === toCompareDate2.getMonth() &&
            toCompareDate1.getDate() === toCompareDate2.getDate()
          ) {
            if (route.Departure.DepAirportCodeLat == aeroexp[i].CodeArr) {
              return aeroexp[i];
            } else if (route.Arrival.ArrAirportCodeLat == aeroexp[i].CodeDep) {
              return aeroexp[i];
            }
          }
        }
      },
      getNewPriceDescr(item: any) {
        // let pass = item.Passid;
        // let type = item.ItemType;
        // let total = item.Total;
        let newCalc: any = [{ price: 0, passId: 0 }];
        newCalc[0].passId = item.Passid;
        newCalc[0].price = 0;
        for (let i = 0; i < item.length; i++) {
          for (let j = 0; j < item.length; j++) {
            if (newCalc[i].passId && item[j].Passid == newCalc[i].passId) {
              newCalc[i].price += item[j].Total;
            }
          }
        }
        return newCalc;
      },
      getNewPrice(item: any) {
        let price = 0;
        let id = 0;
        for (let i = 0; i < item.length; i++) {
          if (id == 0) {
            id = item[i].Passid;
            price += item[i].Total;
          } else if (id == item[i].Passid) {
            price += item[i].Total;
          } else {
            return price;
          }
        }
        console.log(price);
        return price;
      },
      getNightHours(date: any) {
        let depDate = new Date(date);
        let hours = depDate.getHours();
        if (hours >= 22 || (hours >= 0 && hours <= 6)) {
          return true;
        } else {
          return false;
        }
      },
      getTimeOfRoute(depDate: any, arrDate: any) {
        let depTime = new Date(depDate);
        let arrTime = new Date(arrDate);
        let diffCount: any = depTime.valueOf() - arrTime.valueOf();
        let finalHours = Math.floor((diffCount % 86400000) / 3600000);
        let finalMinutes = Math.floor(
          ((diffCount % 86400000) % 3600000) / 60000
        );
        return finalHours + "ч " + finalMinutes + "м в пути";
      },
      getHoursTransferTime(depTrans: any, arrTrans: any) {
        let depTime = new Date(depTrans);
        let arrTime = new Date(arrTrans);
        let diffCount: any = depTime.valueOf() - arrTime.valueOf();
        let finalHours = Math.floor((diffCount % 86400000) / 3600000);
        let finalMinutes = Math.round(
          ((diffCount % 86400000) % 3600000) / 60000
        );
        return finalHours + "ч " + finalMinutes + "м";
      },
      declOfHours(number: any, words: any) {
        return words[
          number % 100 > 4 && number % 100 < 20
            ? 2
            : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
        ];
      },
      hide() {
        this.$emit("update:visible", false);
      },
      getWeekDay(date: any) {
        let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
        let weekDay = new Date(date);
        return days[weekDay.getDay()];
      },
      getDate(date: any) {
        let month = [
          "янв",
          "фев",
          "мар",
          "апр",
          "мая",
          "июн",
          "июл",
          "авг",
          "сен",
          "окт",
          "ноя",
          "дек",
        ];
        let monthNum = new Date(date);
        return monthNum.getDate() + " " + month[monthNum.getMonth()];
      },
      getDotDate(date: any) {
        let dotDate;
        let fullDate = new Date(date);
        let day = fullDate.getDate();
        let month = fullDate.getMonth();
        let fullMonth;
        let year = fullDate.getFullYear();
        if (month < 10) {
          fullMonth = "0" + month;
        } else {
          fullMonth = month;
        }
        dotDate = day + "." + fullMonth + "." + year;
        return dotDate;
      },
      getTime(date: any) {
        let time = new Date(date);
        let hours = time.getHours();
        let minutes = time.getMinutes();
        if (minutes < 10) {
          return hours + ":0" + minutes;
        }
        return hours + ":" + minutes;
      },
      getCompanyLogo(company: any) {
        console.log(`("../assets/images/companies/${company}.svg")`);
        return `"@/assets/images/companies/${company}.svg"`;
      },
      getCreatedDate(date: any) {
        function pad(n: any) {
          return n < 10 ? "0" + n : n;
        }
        const now = new Date(date);
        const tz = now.getTimezoneOffset();
        const sign = tz > 0 ? "-" : "+";
        const hours = pad(Math.floor(Math.abs(tz) / 60));
        const minutes = pad(Math.abs(tz) % 60);
        const tzOffset = sign + hours + ":" + minutes;
        const localDateTime =
          now.getFullYear() +
          "-" +
          pad(now.getMonth() + 1) +
          "-" +
          pad(now.getDate()) +
          "T" +
          pad(now.getHours()) +
          ":" +
          pad(now.getMinutes()) +
          ":" +
          pad(now.getSeconds());
        const eventDate = {
          utc: now.toISOString(),
          local: localDateTime,
          tzOffset: tzOffset,
        };

        const localDateString = eventDate.local;
        const localDate = new Date(localDateString);

        let created: any = new Date(localDate);
        if (tz < 0) {
          created.setHours(
            created.getHours() - 10 + Math.floor(Math.abs(tz) / 60)
          );
          created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
        } else if (tz > 0) {
          created.setHours(
            created.getHours() - 10 - Math.floor(Math.abs(tz) / 60)
          );
          created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
        }

        let createdDay = created.getDate();
        let createdMonth: any = created.getMonth();
        let createdYear = created.getFullYear();
        let createdHours = function () {
          if (created.getHours() < 10) {
            return "0" + created.getHours();
          } else {
            return created.getHours();
          }
        };
        let createdMinutes = function () {
          if (created.getMinutes() < 10) {
            return "0" + created.getMinutes();
          } else {
            return created.getMinutes();
          }
        };

        return (
          createdDay +
          " " +
          this.month[createdMonth] +
          " " +
          createdYear +
          " " +
          createdHours() +
          ":" +
          createdMinutes() +
          " (UTC " +
          tzOffset +
          ")"
        );
      },
      getLimitDate(date: any) {
        function pad(n: any) {
          return n < 10 ? "0" + n : n;
        }
        const now = new Date(date);
        const tz = now.getTimezoneOffset();
        const sign = tz > 0 ? "-" : "+";
        const hours = pad(Math.floor(Math.abs(tz) / 60));
        const minutes = pad(Math.abs(tz) % 60);
        const tzOffset = sign + hours + ":" + minutes;
        const localDateTime =
          now.getFullYear() +
          "-" +
          pad(now.getMonth() + 1) +
          "-" +
          pad(now.getDate()) +
          "T" +
          pad(now.getHours()) +
          ":" +
          pad(now.getMinutes()) +
          ":" +
          pad(now.getSeconds());
        const eventDate = {
          utc: now.toISOString(),
          local: localDateTime,
          tzOffset: tzOffset,
        };

        const localDateString = eventDate.local;
        const localDate = new Date(localDateString);

        let created: any = new Date(localDate);

        if (tz < 0) {
          created.setHours(created.getHours() + Math.floor(Math.abs(tz) / 60));
          created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
        } else if (tz > 0) {
          created.setHours(created.getHours() - Math.floor(Math.abs(tz) / 60));
          created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
        }

        let createdDay = created.getDate();
        let createdMonth: any = created.getMonth();
        let createdYear = created.getFullYear();
        let createdHours = function () {
          if (created.getHours() < 10) {
            return "0" + created.getHours();
          } else {
            return created.getHours();
          }
        };
        let createdMinutes = function () {
          if (created.getMinutes() < 10) {
            return "0" + created.getMinutes();
          } else {
            return created.getMinutes();
          }
        };

        return (
          createdDay +
          " " +
          this.month[createdMonth] +
          " " +
          createdYear +
          " " +
          createdHours() +
          ":" +
          createdMinutes() +
          " (UTC " +
          tzOffset +
          ")"
        );
      },
      getTimeLimit(date: any) {
        function pad(n: any) {
          return n < 10 ? "0" + n : n;
        }
        const now = new Date(date);
        const tz = now.getTimezoneOffset();
        const sign = tz > 0 ? "-" : "+";
        const hours = pad(Math.floor(Math.abs(tz) / 60));
        const minutes = pad(Math.abs(tz) % 60);
        const tzOffset = sign + hours + ":" + minutes;
        const localDateTime =
          now.getFullYear() +
          "-" +
          pad(now.getMonth() + 1) +
          "-" +
          pad(now.getDate()) +
          "T" +
          pad(now.getHours()) +
          ":" +
          pad(now.getMinutes()) +
          ":" +
          pad(now.getSeconds());
        const eventDate = {
          utc: now.toISOString(),
          local: localDateTime,
          tzOffset: tzOffset,
        };

        const localDateString = eventDate.local;
        const localDate = new Date(localDateString);
        let limit = new Date(localDateTime);
        if (tz < 0) {
          limit.setHours(limit.getHours() + Math.floor(Math.abs(tz) / 60));
          limit.setMinutes(limit.getMinutes() + (Math.abs(tz) % 60));
        } else if (tz > 0) {
          limit.setHours(limit.getHours() - Math.floor(Math.abs(tz) / 60));
          limit.setMinutes(limit.getMinutes() - (Math.abs(tz) % 60));
        }

        let today = new Date();
        if (limit > today) {
          return true;
        } else {
          return false;
        }
      },

      getOrderStatus(num: number) {
        if (num == 40) {
          return "Забронирован";
        } else if (num == 60) {
          return "Оформлен";
        } else if (num == 55 || num == 65) {
          return "Обрабатывается";
        } else if (
          num == 70 ||
          num == 71 ||
          num == 72 ||
          num == 73 ||
          num == 74
        ) {
          return "Отменён";
        }
      },
      getTicketStatus(state: number) {
        if (state == 10) {
          return "Создан";
        } else if (state == 20) {
          return "Выпущен";
        } else if (state == 30) {
          return "Аннулирован";
        } else if (state == 40) {
          return "Возвращен";
        } else if (state == 50) {
          return "Обменян";
        }
      },
      getDateWithDot(date: string) {
        let parseDate = new Date(date);
        let day = parseDate.getDate();
        let month = parseDate.getMonth();
        let year = parseDate.getFullYear();
        return day + " " + this.month[month] + " " + year;
      },
      getTotalPrice(Passengers: any) {
        let totalPrice = 0;
        for (const elem of Passengers) {
          let items = elem.Items;
          for (const el of items) {
            totalPrice += el.Amount;
          }
        }
        return totalPrice;
      },
      getPriceType(items: any) {
        let newArr: any = [{ Description: "Авиабилет", Amount: 0 }];
        for (const elem of items) {
          if (
            elem.ItemType == 1 ||
            elem.ItemType == 202 ||
            elem.ItemType == 335
          ) {
            newArr[0].Amount += elem.Amount;
          } else {
            newArr.push(elem);
          }
        }
        return newArr;
      },
      ticketSave(num: any) {
        window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/itinerary`;
      },
      insurSave(url: any) {
        window.location.href = url;
      },
      taxSave(num: any) {
        window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/tax`;
      },
      onClickAwayTicket(index: any) {
        this.optnTicketOpen[index] = false;
      },
      onClickAwayInsur(index: any) {
        this.optnInsurOpen[index] = false;
      },
      onClickAwayTax(index: any) {
        this.optnTaxOpen[index] = false;
      },
      saveCheck(check: any) {
        if (new Date(check.Created) < new Date("2021-07-02")) {
          return `https://check.ofd.ru/rec/2722046551/0001024243050065/9281000100190066/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        } else if (new Date(check.Created) < new Date("2021-08-05")) {
          return `https://check.ofd.ru/rec/2722046551/0002583594045857/9281000100190065/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        } else if (new Date(check.Created) < new Date("2024-08-16")) {
          return `https://check.ofd.ru/rec/2722046551/0002583594045857/9961440300003121/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        } else {
          return `https://check.ofd.ru/rec/2722046551/0002583594045857/7381440800279896/${check.KkmReceiptNumber}/${check.FiscalSign}`;
        }
      },
      getRequesterMail() {
        let mailInfo = sessionStorage.getItem("userName");
        let mail;
        if (mailInfo) {
          mail = JSON.parse(mailInfo);
          return mail;
        } else {
          return "";
        }
      },
      getRouteDataForLink(route: any) {
        let routeData = "";
        for (let i = 0; i < route.length; i++) {
          let date = route[i].DepartureDate;
          let flightNum =
            route[i].OperatingAirline.CodeLat + "-" + route[i].FlightNumber;
          let routeCitys =
            route[i].Departure.City.NameRus +
            "-" +
            route[i].Arrival.City.NameRus;
          let routeString =
            this.getDotDate(date) +
            " " +
            this.getTime(date) +
            " / " +
            flightNum +
            " / " +
            routeCitys +
            "<br>";
          routeData += routeString;
        }
        return routeData;
      },
    },
    created() {
      this.getOrder();
      const unregisterRouterGuard = this.$router.beforeEach(
        (to: any, from: any, next: any) => {
          if (
            this.visibleBottom == true ||
            this.visiblePrice == true ||
            (this.visibleTickets == true &&
              this.optnInsurOpen[0] == false &&
              this.optnInsurOpen[1] == false &&
              this.optnInsurOpen[2] == false &&
              this.optnInsurOpen[3] == false &&
              this.optnInsurOpen[4] == false &&
              this.optnInsurOpen[5] == false &&
              this.optnInsurOpen[6] == false &&
              this.optnInsurOpen[7] == false &&
              this.optnTaxOpen[0] == false &&
              this.optnTaxOpen[1] == false &&
              this.optnTaxOpen[2] == false &&
              this.optnTaxOpen[3] == false &&
              this.optnTaxOpen[4] == false &&
              this.optnTaxOpen[5] == false &&
              this.optnTaxOpen[6] == false &&
              this.optnTaxOpen[7] == false &&
              this.optnTicketOpen[0] == false &&
              this.optnTicketOpen[1] == false &&
              this.optnTicketOpen[2] == false &&
              this.optnTicketOpen[3] == false &&
              this.optnTicketOpen[4] == false &&
              this.optnTicketOpen[5] == false &&
              this.optnTicketOpen[6] == false &&
              this.optnTicketOpen[7] == false)
          ) {
            // event.preventDefault;
            next(false);
            this.visibleBottom = false;
            this.visiblePrice = false;
            this.visibleTickets = false;
            // this.optnInsurOpen[0] = false;
            // this.optnInsurOpen[1] = false;
            // this.optnInsurOpen[2] = false;
            // this.optnInsurOpen[3] = false;
            // this.optnInsurOpen[4] = false;
            // this.optnInsurOpen[5] = false;
            // this.optnInsurOpen[6] = false;
            // this.optnInsurOpen[7] = false;
            // this.optnTaxOpen[0] = false;
            // this.optnTaxOpen[1] = false;
            // this.optnTaxOpen[2] = false;
            // this.optnTaxOpen[3] = false;
            // this.optnTaxOpen[4] = false;
            // this.optnTaxOpen[5] = false;
            // this.optnTaxOpen[6] = false;
            // this.optnTaxOpen[7] = false;
            // this.optnTicketOpen[0] = false;
            // this.optnTicketOpen[1] = false;
            // this.optnTicketOpen[2] = false;
            // this.optnTicketOpen[3] = false;
            // this.optnTicketOpen[4] = false;
            // this.optnTicketOpen[5] = false;
            // this.optnTicketOpen[6] = false;
            // this.optnTicketOpen[7] = false;
            // history.go(1);
          } else if (
            this.optnInsurOpen[0] == true ||
            this.optnInsurOpen[1] == true ||
            this.optnInsurOpen[2] == true ||
            this.optnInsurOpen[3] == true ||
            this.optnInsurOpen[4] == true ||
            this.optnInsurOpen[5] == true ||
            this.optnInsurOpen[6] == true ||
            this.optnInsurOpen[7] == true ||
            this.optnTaxOpen[0] == true ||
            this.optnTaxOpen[1] == true ||
            this.optnTaxOpen[2] == true ||
            this.optnTaxOpen[3] == true ||
            this.optnTaxOpen[4] == true ||
            this.optnTaxOpen[5] == true ||
            this.optnTaxOpen[6] == true ||
            this.optnTaxOpen[7] == true ||
            this.optnTicketOpen[0] == true ||
            this.optnTicketOpen[1] == true ||
            this.optnTicketOpen[2] == true ||
            this.optnTicketOpen[3] == true ||
            this.optnTicketOpen[4] == true ||
            this.optnTicketOpen[5] == true ||
            this.optnTicketOpen[6] == true ||
            this.optnTicketOpen[7] == true
          ) {
            next();
          } else {
            next();
          }
        }
      );
    },
    directives: {
      ripple: Ripple,
    },
  });
</script>

<style>
  .passengers-card {
    text-decoration: none;
  }

  .toast-msg {
    max-width: 70%;
  }

  .p-toast .p-toast-message .p-toast-message-content {
    align-items: center !important;
  }

  .p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon {
    font-size: 18px !important;
  }

  .choosen-order__info-paybtn__link {
    text-decoration: none;
  }

  .choosen-order__info-status {
    padding: 5px;
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .choosen-order__info-status__icon {
    margin-right: 5px;
  }

  .choosen-order__unfindable {
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    overflow: hidden;
    padding: 30px 10px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }

  .choosen-order__unfindable-icon {
    height: 30px;
    width: 30px;
  }

  .choosen-order__unfindable-text {
    margin-left: 10px;
  }

  .p-button.p-button-sm {
    font-size: 1rem !important;
  }

  @media screen and (max-width: 767px) {
    .choosen-order__info-wrapper {
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__info-numstat {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-number {
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #000000;
    }

    .status-succes {
      background: #3ad35b !important;
      border: 1px solid #3ad35b !important;
    }

    .choosen-order__info-created {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-created__title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #666666;
    }

    .choosen-order__info-created__value {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }

    .choosen-order__info-timelimit {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-timelimit__title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #666666;
    }

    .choosen-order__info-timelimit__value {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }

    .choosen-order__info-price {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-price__title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__info-paybtn {
      background-color: #f37e21 !important;
      border: 1px solid #f37e21 !important;
      width: 100%;
      margin-top: 15px !important;
    }

    .choosen-order__info-supportbtn {
      margin-top: 15px !important;
      text-decoration: none;
      width: 100%;
    }

    .choosen-order__info-cancelbtn {
      width: 100%;
      margin-top: 5px !important;
    }

    .choosen-order__info-ticketsbtn {
      background-color: #f37e21 !important;
      border: 1px solid #f37e21 !important;
      width: 100%;
      margin-top: 15px !important;
    }

    /* tickets info */

    .choosen-order__info-tickets__header {
      font-size: 20px;
      color: #000;
      margin-bottom: 20px;
    }

    .choosen-order__info-tickets__title {
      font-size: 18px;
      font-weight: bold;
      color: #000;
    }

    .choosen-order__info-tickets__ticket {
      margin-top: 25px;
      margin-bottom: 20px;
    }

    .choosen-order__info-tickets__ticket-title {
      font-size: 1.1rem;
      font-weight: bold;
    }

    .choosen-order__info-tickets__ticket-num {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-num__wrapper {
      display: flex;
      align-items: center;
      width: 50%;
    }

    .choosen-order__info-tickets__ticket-num__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .choosen-order__info-tickets__ticket-num__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-insur {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-insur__wrapper {
      display: flex;
      align-items: center;
      width: 50%;
    }

    .choosen-order__info-tickets__ticket-insur__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .choosen-order__info-tickets__ticket-insur__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-tax {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-tax__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-tax__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    /* tickets sidebar savebtn*/

    .choosen-order__info-tickets__ticket-num__btn {
      display: flex;
      position: relative;
    }

    .ticket-num__btn-status {
      max-height: 39px;
      color: #ffffff;
      background: #2196f3;
      border: 1px solid #2196f3;
      padding: 0.5rem 1rem;
      font-size: 1rem;
      transition: background-color 0.2s, color 0.2s, border-color 0.2s,
        box-shadow 0.2s;
      border-radius: 3px;
      display: flex;

      text-align: center;
      align-items: center;
      vertical-align: bottom;
      text-align: center;
      overflow: hidden;
    }

    .ticket-num__btn-select__icon {
      width: 16px;
      height: 16px;
      margin-left: 24px;
    }

    .ticket-num__btn-options {
      transform-origin: center top;
      top: 145px;
      left: 181px;
      min-width: 140px;
      z-index: 2102;
      border-radius: 3px;
      width: 18.5rem;
      color: #495057;
      padding: 0.25rem 0;
      background: #ffffff;
      border: 0 none;
      visibility: hidden;
      position: absolute;
      top: 36px;
      left: -152px;
      opacity: 0;
      display: block;
      transition: visibility 0.3s, opacity 0.3s;
      box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
        0 1px 10px 0 rgb(0 0 0 / 12%);
    }

    .optionsopened {
      visibility: visible;
      opacity: 1;
    }

    .ticket-num__btn-options__save {
      cursor: pointer;
      display: flex;
      align-items: center;
      min-height: 35px;
    }

    .ticket-num__btn-options__save-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__change {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__change-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__change-link {
      text-decoration: none;
      color: #495057;
    }

    .ticket-num__btn-options__refund {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__refund-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__refund-link {
      text-decoration: none;
      color: #495057;
    }

    .ticket-num__btn-options__cancel {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__cancel-icon {
      width: 14px;
      height: 14px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__cancel-link {
      text-decoration: none;
      color: #495057;
    }

    .p-splitbutton .p-splitbutton-defaultbutton[data-v-76d71c64] {
      border-right: 1px solid #2196f3;
    }

    /* tickets-save-btn */

    .choosen-order__info-tickets__download {
      width: 100%;
    }

    .choosen-order__info-tickets__refund {
      width: 100%;
      margin-top: 5px !important;
    }

    .choosen-order__info-tickets__cancel {
      width: 100%;
      margin-top: 5px !important;
      margin-bottom: 15px !important;
    }

    /* route info */
    .choosen-order__wrapper {
      margin-top: 15px;
    }

    .choosen-order__oneway-route {
      font-weight: 600;
      font-style: normal;
      font-size: 18px;
      margin-left: 5px;
    }

    .choosen-order__oneway-text {
      margin-left: 5px;
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      color: #666666;
    }

    .choosen-order__card {
      margin-top: 10px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__card-wrapper {
      align-items: center;
    }

    .choose-order__card-company {
      display: flex;
      align-items: center;
    }

    .choose-order__card-company__info {
      margin-left: 10px;
    }

    .choose-order__card-company__info-name {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
    }

    .choose-order__card-company__info-duration {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      color: #666666;
    }

    .p-sidebar {
      background-color: #e9e9e9 !important;
    }

    .rule-hint {
      color: cornflowerblue;
      text-decoration: underline;
    }

    .rule-hint[original-title]:hover::before {
      content: attr(original-title);
      position: absolute;
      left: 0;
      bottom: 0px;
      display: inline-block;
      padding: 3px 6px;
      border-radius: 2px;
      background: rgb(138, 204, 243);
      color: #000;
      font-size: 12px;
      min-width: 250px;
      white-space: normal;
      z-index: 5;
    }

    .choosen-order__card-route {
      display: flex;
      margin-bottom: 20px;
    }

    .choosen-order__card-route__scheme {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-top: 15px;
    }

    .choosen-order__card-route__scheme-marker {
      width: 1rem;
      height: 1rem;
      border: 5px solid #9e9e9e;
      border-radius: 50%;
      color: #9e9e9e;
    }

    .choosen-order__card-route__scheme-connector {
      width: 2px;
      min-height: 50px;
      max-height: 50px;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      background-color: #9e9e9e;
    }

    .choosen-order__card-route__dates {
      margin-top: 13px;
      margin-left: 25px;
    }

    .choosen-order__card-route__dates-departure__time {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__dates-departure__date {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__dates-arrival {
      margin-top: 30px;
    }

    .choosen-order__card-route__dates-arrival__time {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__dates-arrival__date {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__citys {
      margin-top: 13px;
      margin-left: 25px;
    }

    .choosen-order__card-route__citys-departure__city {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__citys-departure__airport {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__citys-arrival {
      margin-top: 30px;
    }

    .choosen-order__card-route__citys-arrival__city {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__citys-arrival__airport {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-info__wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choose-order__card-company__logo-img {
      border-radius: 50%;
    }

    .choosen-order__card-transfer {
      display: flex;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 30px;
      padding: 8px;
      border-radius: 3px;
      background-color: #e9e9e9;
    }

    .choosen-order__card-transfer__icon {
      width: 25px;
      height: 25px;
    }

    .choosen-order__card-transfer__info {
      margin-left: 10px;
    }

    .choosen-order__card-transfer__info-city {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      line-height: 16px;
      color: #4e4e4e;
    }

    .choosen-order__card-transfer__info-duration {
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #4e4e4e;
    }

    /* night transfer */

    .choosen-order__card-transfer__night {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 8px 20px 8px 8px;
      border-radius: 3px;
      background-color: #485367;
    }
    .choosen-order__card-transfer__info-wrapper {
      background-color: #485367;
      border-radius: 3px;
      display: flex;
      align-items: center;
    }

    .choosen-order__card-transfer__info-city__night {
      color: #ffffff;
      margin-right: 10px;
    }

    .choosen-order__card-transfer__info-duration__night {
      color: #ffffff;
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
    }

    .choosen-order__card-transfer__info-icon {
      max-height: 22px;
      max-width: 22px;
      margin-right: 0;
      margin-left: auto;
    }

    /* Night sidebar */

    .p-sidebar-bottom {
      height: 15rem !important;
    }

    .choosen-order__card-transfer__info-night__wrapper {
      display: flex;
      align-items: center;
    }

    .choosen-order__card-transfer__info-night__icon {
      width: 35px;
      height: 35px;
      margin-right: 15px;
    }

    .choosen-order__card-transfer__info-night__text {
      margin-top: 10px;
    }

    .choosen-order__arrival-block {
      margin-top: 20px;
    }

    /* info block */

    .choosen-order__info-order {
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-passengers {
      margin-top: 15px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-passengers__title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-passengers__wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-passengers-passenger__wrapper {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-passengers__name {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }

    .choosen-order__info-passengers__btn {
      max-height: 35px;
    }

    /* .choosen-order__info-passengers__descr {
    display: none;
    min-height: 100vh;
    min-width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    padding: 30px 5px 15px 15px;
    background-color: #e9e9e9;
  } */

    /* .pass-visible {
    display: block;
    z-index: 1001;
  } */

    .choosen-order__info-contacts {
      margin-top: 20px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-contacts__title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__email {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }

    .choosen-order__info-contacts__email-title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__email-value {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }

    .choosen-order__info-contacts__phone {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-contacts__phone-title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__phone-value {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .choosen-order__info-wrapper {
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-title {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      color: #666666;
    }

    .choosen-order__info-numstat {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-number {
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #000000;
    }

    .status-succes {
      background: #3ad35b !important;
      border: 1px solid #3ad35b !important;
    }

    .choosen-order__info-created {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-created__title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__info-created__value {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #000000;
    }

    .choosen-order__info-timelimit {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-timelimit__title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__info-timelimit__value {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #000000;
    }

    .choosen-order__info-price {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-price__title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__info-paybtn {
      background-color: #f37e21 !important;
      border: 1px solid #f37e21 !important;
      width: 100%;
      margin-top: 15px !important;
    }

    .choosen-order__info-supportbtn {
      margin-top: 15px !important;
      text-decoration: none;
      width: 100%;
    }

    .choosen-order__info-cancelbtn {
      width: 100%;
      margin-top: 5px !important;
    }

    .choosen-order__info-ticketsbtn {
      background-color: #f37e21 !important;
      border: 1px solid #f37e21 !important;
      width: 100%;
      margin-top: 15px !important;
    }

    /* tickets info */
    .choosen-order__info-tickets__header {
      font-size: 20px;
      color: #000;
      margin-bottom: 20px;
    }

    .choosen-order__info-tickets__title {
      font-size: 18px;
      font-weight: bold;
      color: #000;
    }

    .choosen-order__info-tickets__ticket {
      margin-top: 25px;
      margin-bottom: 20px;
    }

    .choosen-order__info-tickets__ticket-title {
      font-size: 1.1rem;
      font-weight: bold;
    }

    .choosen-order__info-tickets__ticket-num {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-num__wrapper {
      display: flex;
      align-items: center;
      width: 50%;
    }

    .choosen-order__info-tickets__ticket-num__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .choosen-order__info-tickets__ticket-num__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-insur {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-insur__wrapper {
      display: flex;
      align-items: center;
      width: 50%;
    }

    .choosen-order__info-tickets__ticket-insur__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .choosen-order__info-tickets__ticket-insur__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-tax {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-tax__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-tax__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    /* tickets sidebar savebtn*/

    .choosen-order__info-tickets__ticket-num__btn {
      display: flex;
      position: relative;
    }

    .ticket-num__btn-status {
      max-height: 39px;
      color: #ffffff;
      background: #2196f3;
      border: 1px solid #2196f3;
      padding: 0.5rem 1rem;
      font-size: 1rem;
      transition: background-color 0.2s, color 0.2s, border-color 0.2s,
        box-shadow 0.2s;
      border-radius: 3px;
      display: flex;

      text-align: center;
      align-items: center;
      vertical-align: bottom;
      text-align: center;
      overflow: hidden;
    }

    .ticket-num__btn-select__icon {
      width: 16px;
      height: 16px;
      margin-left: 24px;
    }

    .ticket-num__btn-options {
      transform-origin: center top;
      top: 145px;
      left: 181px;
      min-width: 140px;
      z-index: 2102;
      border-radius: 3px;
      width: 18.5rem;
      color: #495057;
      padding: 0.25rem 0;
      background: #ffffff;
      border: 0 none;
      visibility: hidden;
      position: absolute;
      top: 36px;
      left: -152px;
      opacity: 0;
      display: block;
      transition: visibility 0.3s, opacity 0.3s;
      box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
        0 1px 10px 0 rgb(0 0 0 / 12%);
    }

    .optionsopened {
      visibility: visible;
      opacity: 1;
    }

    .ticket-num__btn-options__save {
      cursor: pointer;
      display: flex;
      align-items: center;
      min-height: 35px;
    }

    .ticket-num__btn-options__save-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__change {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__change-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__change-link {
      text-decoration: none;
      color: #495057;
    }

    .ticket-num__btn-options__refund {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__refund-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__refund-link {
      text-decoration: none;
      color: #495057;
    }

    .ticket-num__btn-options__cancel {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__cancel-icon {
      width: 14px;
      height: 14px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__cancel-link {
      text-decoration: none;
      color: #495057;
    }

    .p-splitbutton .p-splitbutton-defaultbutton[data-v-76d71c64] {
      border-right: 1px solid #2196f3;
    }

    /* tickets-save-btn */

    .choosen-order__info-tickets__download {
      width: 100%;
    }

    .choosen-order__info-tickets__refund {
      width: 100%;
      margin-top: 5px !important;
    }

    .choosen-order__info-tickets__cancel {
      width: 100%;
      margin-top: 5px !important;
      margin-bottom: 15px !important;
    }

    /* route info */
    .choosen-order__wrapper {
      margin-top: 15px;
    }

    .choosen-order__oneway-route {
      font-weight: 600;
      font-style: normal;
      font-size: 18px;
      margin-left: 5px;
    }

    .choosen-order__oneway-text {
      margin-left: 5px;
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      color: #666666;
    }

    .choosen-order__card {
      margin-top: 10px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__card-wrapper {
      align-items: center;
    }

    .choose-order__card-company {
      display: flex;
      align-items: center;
    }

    .choose-order__card-company__info {
      margin-left: 10px;
    }

    .choose-order__card-company__info-name {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
    }

    .choose-order__card-company__info-duration {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      color: #666666;
    }

    .p-sidebar {
      background-color: #e9e9e9 !important;
    }

    .rule-hint {
      color: cornflowerblue;
      text-decoration: underline;
    }

    .rule-hint[original-title]:hover::before {
      content: attr(original-title);
      position: absolute;
      left: 0;
      bottom: 0px;
      display: inline-block;
      padding: 3px 6px;
      border-radius: 2px;
      background: rgb(138, 204, 243);
      color: #000;
      font-size: 12px;
      min-width: 250px;
      white-space: normal;
      z-index: 5;
    }

    .choosen-order__card-route {
      display: flex;
      margin-bottom: 20px;
    }

    .choosen-order__card-route__scheme {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-top: 15px;
    }

    .choosen-order__card-route__scheme-marker {
      width: 1rem;
      height: 1rem;
      border: 5px solid #9e9e9e;
      border-radius: 50%;
      color: #9e9e9e;
    }

    .choosen-order__card-route__scheme-connector {
      width: 2px;
      min-height: 50px;
      max-height: 50px;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      background-color: #9e9e9e;
    }

    .choosen-order__card-route__dates {
      margin-top: 13px;
      margin-left: 25px;
    }

    .choosen-order__card-route__dates-departure__time {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__dates-departure__date {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__dates-arrival {
      margin-top: 30px;
    }

    .choosen-order__card-route__dates-arrival__time {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__dates-arrival__date {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__citys {
      margin-top: 13px;
      margin-left: 25px;
    }

    .choosen-order__card-route__citys-departure__city {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__citys-departure__airport {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__citys-arrival {
      margin-top: 30px;
    }

    .choosen-order__card-route__citys-arrival__city {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      line-height: 18px;
    }

    .choosen-order__card-route__citys-arrival__airport {
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-info__wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choose-order__card-company__logo-img {
      border-radius: 50%;
    }

    .choosen-order__card-transfer {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 8px;
      border-radius: 3px;
      background-color: #e9e9e9;
    }

    .choosen-order__card-transfer__icon {
      width: 25px;
      height: 25px;
    }

    .choosen-order__card-transfer__info {
      margin-left: 10px;
    }

    .choosen-order__card-transfer__info-city {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      line-height: 16px;
      color: #4e4e4e;
    }

    .choosen-order__card-transfer__info-duration {
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #4e4e4e;
    }

    /* night transfer */

    .choosen-order__card-transfer__night {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 8px 20px 8px 8px;
      border-radius: 3px;
      background-color: #485367;
    }
    .choosen-order__card-transfer__info-wrapper {
      background-color: #485367;
      border-radius: 3px;
      display: flex;
      align-items: center;
    }

    .choosen-order__card-transfer__info-city__night {
      color: #ffffff;
      margin-right: 10px;
    }

    .choosen-order__card-transfer__info-duration__night {
      color: #ffffff;
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
    }

    .choosen-order__card-transfer__info-icon {
      max-height: 22px;
      max-width: 22px;
      margin-right: 0;
      margin-left: auto;
    }

    /* Night sidebar */

    .p-sidebar-bottom {
      height: 15rem !important;
    }

    .choosen-order__card-transfer__info-night__wrapper {
      display: flex;
      align-items: center;
    }

    .choosen-order__card-transfer__info-night__icon {
      width: 35px;
      height: 35px;
      margin-right: 15px;
    }

    .choosen-order__card-transfer__info-night__text {
      margin-top: 10px;
    }

    .choosen-order__arrival-block {
      margin-top: 20px;
    }

    /* info block */

    .choosen-order__info-order {
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-passengers {
      margin-top: 15px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-passengers__title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-passengers__wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-passengers-passenger__wrapper {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-passengers__name {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }

    .choosen-order__info-passengers__btn {
      max-height: 35px;
    }

    .choosen-order__info-contacts {
      margin-top: 20px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-contacts__title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__email {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }

    .choosen-order__info-contacts__email-title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__email-value {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }

    .choosen-order__info-contacts__phone {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-contacts__phone-title {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__phone-value {
      font-weight: 500;
      font-style: normal;
      font-size: 15px;
      color: #000000;
    }
  }

  @media screen and (min-width: 1025px) {
    .choosen-order__info-wrapper {
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__info-numstat {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-number {
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #000000;
    }

    .status-succes {
      background: #3ad35b !important;
      border: 1px solid #3ad35b !important;
    }

    .choosen-order__info-created {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-created__title {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      color: #666666;
    }

    .choosen-order__info-created__value {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      color: #000000;
    }

    .choosen-order__info-timelimit {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-timelimit__title {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      color: #666666;
    }

    .choosen-order__info-timelimit__value {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      color: #000000;
    }

    .choosen-order__info-price {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-price__title {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
      color: #666666;
    }

    .choosen-order__info-paybtn {
      background-color: #f37e21 !important;
      border: 1px solid #f37e21 !important;
      width: 100%;
      margin-top: 15px !important;
      font-size: 18px !important;
    }

    .choosen-order__info-cancelbtn {
      width: 100%;
      margin-top: 5px !important;
      font-size: 18px !important;
    }

    .choosen-order__info-ticketsbtn {
      background-color: #f37e21 !important;
      border: 1px solid #f37e21 !important;
      width: 100%;
      margin-top: 15px !important;
      font-size: 16px !important;
    }

    /* tickets info */
    .choosen-order__info-tickets__header {
      font-size: 18px;
      color: #000;
      margin-bottom: 18px;
    }

    .choosen-order__info-tickets__title {
      font-size: 18px;
      font-weight: bold;
      color: #000;
    }

    .choosen-order__info-tickets__ticket {
      margin-top: 25px;
      margin-bottom: 18px;
    }

    .choosen-order__info-tickets__ticket-title {
      font-size: 1rem;
      font-weight: bold;
    }

    .choosen-order__info-tickets__ticket-num {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-num__wrapper {
      display: flex;
      align-items: center;
      width: 50%;
    }

    .choosen-order__info-tickets__ticket-num__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .choosen-order__info-tickets__ticket-num__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
      font-size: 16px;
    }

    .choosen-order__info-tickets__ticket-insur {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-insur__wrapper {
      display: flex;
      align-items: center;
      width: 50%;
    }

    .choosen-order__info-tickets__ticket-insur__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .choosen-order__info-tickets__ticket-insur__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
      font-size: 16px;
    }

    .choosen-order__info-tickets__ticket-tax {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-tickets__ticket-tax__value {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #000;
    }

    .choosen-order__info-tickets__ticket-tax__icon {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    /* tickets sidebar savebtn*/

    .choosen-order__info-tickets__ticket-num__btn {
      display: flex;
      position: relative;
    }

    .ticket-num__btn-status {
      max-height: 39px;
      color: #ffffff;
      background: #2196f3;
      border: 1px solid #2196f3;
      padding: 0.5rem 1rem;
      font-size: 1rem;
      transition: background-color 0.2s, color 0.2s, border-color 0.2s,
        box-shadow 0.2s;
      border-radius: 3px;
      display: flex;

      text-align: center;
      align-items: center;
      vertical-align: bottom;
      text-align: center;
      overflow: hidden;
    }

    .ticket-num__btn-select__icon {
      width: 16px;
      height: 16px;
      margin-left: 24px;
    }

    .ticket-num__btn-options {
      transform-origin: center top;
      top: 145px;
      left: 181px;
      min-width: 140px;
      z-index: 2102;
      border-radius: 3px;
      width: 18.5rem;
      color: #495057;
      padding: 0.25rem 0;
      background: #ffffff;
      border: 0 none;
      visibility: hidden;
      position: absolute;
      top: 36px;
      left: -152px;
      opacity: 0;
      display: block;
      transition: visibility 0.3s, opacity 0.3s;
      box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
        0 1px 10px 0 rgb(0 0 0 / 12%);
    }

    .optionsopened {
      visibility: visible;
      opacity: 1;
    }

    .ticket-num__btn-options__save {
      cursor: pointer;
      display: flex;
      align-items: center;
      min-height: 35px;
    }

    .ticket-num__btn-options__save:hover {
      background-color: #dbdada;
      cursor: pointer;
    }

    .ticket-num__btn-options__save-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__change {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__change:hover {
      background-color: #dbdada;
      cursor: pointer;
    }

    .ticket-num__btn-options__change-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__change-link {
      text-decoration: none;
      color: #495057;
    }

    .ticket-num__btn-options__refund {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__refund:hover {
      background-color: #dbdada;
      cursor: pointer;
    }

    .ticket-num__btn-options__refund-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__refund-link {
      text-decoration: none;
      color: #495057;
    }

    .ticket-num__btn-options__cancel {
      min-height: 35px;
      display: flex;
      align-items: center;
    }

    .ticket-num__btn-options__cancel:hover {
      background-color: #dbdada;
      cursor: pointer;
    }

    .ticket-num__btn-options__cancel-icon {
      width: 14px;
      height: 14px;
      margin-left: 10px;
      margin-right: 15px;
    }

    .ticket-num__btn-options__cancel-link {
      text-decoration: none;
      color: #495057;
    }

    .p-splitbutton .p-splitbutton-defaultbutton[data-v-76d71c64] {
      border-right: 1px solid #2196f3;
    }

    /* tickets-save-btn */

    .choosen-order__info-tickets__download {
      width: 100%;
    }

    .choosen-order__info-tickets__refund {
      width: 100%;
      margin-top: 5px !important;
    }

    .choosen-order__info-tickets__cancel {
      width: 100%;
      margin-top: 5px !important;
      margin-bottom: 15px !important;
    }

    /* route info */
    .choosen-order__wrapper {
      margin-top: 15px;
    }

    .choosen-order__oneway-route {
      font-weight: 600;
      font-style: normal;
      font-size: 18px;
      margin-left: 5px;
    }

    .choosen-order__oneway-text {
      margin-left: 5px;
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .choosen-order__card {
      margin-top: 10px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__card-wrapper {
      align-items: center;
    }

    .choose-order__card-company {
      display: flex;
      align-items: center;
    }

    .choose-order__card-company__info {
      margin-left: 10px;
    }

    .choose-order__card-company__info-name {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
    }

    .choose-order__card-company__info-duration {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
    }

    .p-sidebar {
      background-color: #e9e9e9 !important;
    }

    .rule-hint {
      color: cornflowerblue;
      text-decoration: underline;
    }

    .rule-hint[original-title]:hover::before {
      content: attr(original-title);
      position: absolute;
      left: 0;
      bottom: 0px;
      display: inline-block;
      padding: 3px 6px;
      border-radius: 2px;
      background: rgb(138, 204, 243);
      color: #000;
      font-size: 14px;
      min-width: 250px;
      white-space: normal;
      z-index: 5;
    }

    .choosen-order__card-route {
      display: flex;
      margin-bottom: 20px;
    }

    .choosen-order__card-route__scheme {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-top: 15px;
    }

    .choosen-order__card-route__scheme-marker {
      width: 1rem;
      height: 1rem;
      border: 5px solid #9e9e9e;
      border-radius: 50%;
      color: #9e9e9e;
    }

    .choosen-order__card-route__scheme-connector {
      width: 2px;
      min-height: 50px;
      max-height: 50px;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      background-color: #9e9e9e;
    }

    .choosen-order__card-route__dates {
      margin-top: 13px;
      margin-left: 25px;
    }

    .choosen-order__card-route__dates-departure__time {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
    }

    .choosen-order__card-route__dates-departure__date {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__dates-arrival {
      margin-top: 30px;
    }

    .choosen-order__card-route__dates-arrival__time {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
    }

    .choosen-order__card-route__dates-arrival__date {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__citys {
      margin-top: 13px;
      margin-left: 25px;
    }

    .choosen-order__card-route__citys-departure__city {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
    }

    .choosen-order__card-route__citys-departure__airport {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-route__citys-arrival {
      margin-top: 30px;
    }

    .choosen-order__card-route__citys-arrival__city {
      font-weight: 500;
      font-style: normal;
      font-size: 18px;
    }

    .choosen-order__card-route__citys-arrival__airport {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #666666;
      margin-top: 5px;
    }

    .choosen-order__card-info__wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choose-order__card-company__logo-img {
      border-radius: 50%;
    }

    .choosen-order__card-transfer {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 8px;
      border-radius: 3px;
      background-color: #e9e9e9;
    }

    .choosen-order__card-transfer__icon {
      width: 25px;
      height: 25px;
    }

    .choosen-order__card-transfer__info {
      margin-left: 10px;
    }

    .choosen-order__card-transfer__info-city {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      line-height: 16px;
      color: #4e4e4e;
    }

    .choosen-order__card-transfer__info-duration {
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
      color: #4e4e4e;
    }

    /* night transfer */

    .choosen-order__card-transfer__night {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 8px 20px 8px 8px;
      border-radius: 3px;
      background-color: #485367;
    }
    .choosen-order__card-transfer__info-wrapper {
      background-color: #485367;
      border-radius: 3px;
      display: flex;
      align-items: center;
    }

    .choosen-order__card-transfer__info-city__night {
      color: #ffffff;
      margin-right: 10px;
    }

    .choosen-order__card-transfer__info-duration__night {
      color: #ffffff;
      margin-top: 5px;
      font-weight: 500;
      font-style: normal;
      font-size: 14px;
      line-height: 14px;
    }

    .choosen-order__card-transfer__info-icon {
      max-height: 22px;
      max-width: 22px;
      margin-right: 0;
      margin-left: auto;
    }

    /* Night sidebar */

    .p-sidebar-bottom {
      height: 15rem !important;
    }

    .choosen-order__card-transfer__info-night__wrapper {
      display: flex;
      align-items: center;
    }

    .choosen-order__card-transfer__info-night__icon {
      width: 35px;
      height: 35px;
      margin-right: 15px;
    }

    .choosen-order__card-transfer__info-night__text {
      margin-top: 10px;
    }

    .choosen-order__arrival-block {
      margin-top: 20px;
    }

    /* info block */

    .choosen-order__info-order {
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-passengers {
      margin-top: 15px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-passengers__title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #4e4e4e;
    }

    .choosen-order__info-passengers__wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-passengers-passenger__wrapper {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .choosen-order__info-passengers__name {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #000000;
    }

    .choosen-order__info-passengers__btn {
      max-height: 35px;
    }

    .choosen-order__info-contacts {
      margin-top: 20px;
      background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
    }

    .choosen-order__info-contacts__title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__email {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }

    .choosen-order__info-contacts__email-title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__email-value {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #000000;
    }

    .choosen-order__info-contacts__phone {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }

    .choosen-order__info-contacts__phone-title {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #4e4e4e;
    }

    .choosen-order__info-contacts__phone-value {
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      color: #000000;
    }

    .choosen-order__info-supportbtn {
      margin-top: 15px !important;
      text-decoration: none;
      width: 100%;
    }
  }
</style>
